export default __webpack_public_path__ + "static/media/regulatory--no-right-turn-on-red--g1.f6ea7f5c.png";